export const W3C_ELEMENT_ID = 'element-6066-11e4-a52e-4f735466cecf';
export const EDGE_CHROMIUM_MIN_VERSION = 79;
